// extracted by mini-css-extract-plugin
export default {"cls1":"index-cls1___b6e3de710753ac6cb36","cls2":"index-cls2__d8bd7cf440ede6a8b1ab index-cls1___b6e3de710753ac6cb36"};